<template>
    <div class="d-flex flex-row flex-wrap gap-2 align-items-center" v-if="runner.estimation">
        <div v-if="runner.identite.itra > 0" class="itra_value">
            <img src="../../assets/Logo_itra_Simple_N blanc.png" alt="itra" class="itra_logo_filter" /> <span
                style="font-size: 1rem">{{ runner.identite.itra }}</span>
        </div>
        <div class="cote_sportips_value" v-else>
            <img src="../../assets/sportips.png" alt="sportips" class="itra_logo_filter" /> <span
                style="font-size: 1rem">{{ parseInt(runner.estimation.cotation_sportips) }}</span>
        </div>
        <div class="chip_localisation">
            <span v-if="runner.estimation.trackingMethod === 'app'"><v-icon name='mobile'></v-icon>{{
                $t('localisation.appli') }}</span>
            <span v-else-if="runner.estimation.trackingMethod === 'balise'"><v-icon name='satellite'></v-icon>{{
                $t('localisation.balise') }}</span>
            <span v-else><v-icon name='chart-bar'></v-icon>{{ $t('localisation.estime') }}</span>
        </div>
    </div>

</template>

<script>
import InfoLocalisation from "@/components/Live_tab/InfoLocalisation.vue";
export default {
    props: ["runner"],
    components: {
        InfoLocalisation,
    },
}
</script>

<style lang="scss" scoped>
.chip_localisation {
    display: flex;
    flex-direction: row;
    font-weight: bold;
    align-items: center;
    font-size: 1rem;

    width: -webkit-max-content !important;
    width: -moz-max-content !important;
    width: max-content !important;
    padding: 3px 10px;
    border-radius: 5px;
    box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px !important;
    border: 1px solid #6c757d;
}
</style>